import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueResource from 'vue-resource';
import VueVideoPlayer from 'vue-video-player';
import '@/assets/iconfont/iconfont.css';
import 'video.js/dist/video-js.css';
import 'swiper/dist/css/swiper.css';
import '@/utils/resize';
import '@/assets/sass/part/common.scss';


Vue.config.productionTip = false;
Vue.use(VueVideoPlayer);
Vue.use(VueResource);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
